import Vue from 'vue'
import VueRouter from 'vue-router'
import Projects from '../views/Projects.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'projects',
    component: Projects
  },
  {
    path: '/view/station/:station_id',
    name: 'stations',
    component: () => import('../views/Station.vue')
  },
  {
    path: '/view/alarms',
    name: 'alarms',
    component: () => import('../views/EditAlarms.vue')
  },
  {
    path: '/view/contacts',
    name: 'contacts',
    component: () => import('../views/EditContacts.vue')
  },
  {
    path: '/view/groups',
    name: 'groups',
    component: () => import('../views/EditGroups.vue')
  },
  {
    path: '/view/log',
    name: 'log',
    component: () => import('../views/Log.vue')
  },
  {
    path: '/view/frame/:frame_id?',
    name: 'frame',
    component: () => import('../views/Frame.vue')
  },
  {
    path: '/view/test',
    name: 'test',
    component: () => import('../views/Test.vue')
  },
  {
    path: '/*/',
    name: 'PageNotFound',
    component: () => import('../views/PageNotFound.vue')
  }
  /*
  {
    path: '/edit/notifications',
    name: 'EditNotifications',
    component: () => import('../views/EditNotifications.vue')
  }
   */
]

// Build router
const router = new VueRouter({
  mode: 'history',
  routes
})

// Scroll page to top during each navigation event
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})

// Restrict user navigation based on whitelist, if user cant access the selected view direct them to next available view
router.beforeEach((to, from, next) => {
  // Check if user has opened a project
  if (store.state.project === null) {
    next()
  } else {
    // User has opened a project, we need to check against the possible whitelist
    if (store.getters.access(to.name)) {
      next()
    } else {
      // User does not have access to opened view, we need to redirect them to the first whitelisted view
      next({ path: '/view/' + store.state.project.restrictions.find(obj => obj.user === store.state.user.email).whitelist[0] })
    }
  }
})

export default router
